import React, { useEffect, useMemo, useState } from 'react'
import { Button, Modal } from '../../../components'
import problemaacao from './blocks/problemaacao'
import responsavelparticipantes from './blocks/responsavelparticipantes'
import canalferramenta from './blocks/canalferramenta'
import './aprovarplanoplanmodal.scss'

const Problemaacao = problemaacao
const Responsavelparticipantes = responsavelparticipantes
const Canalferramenta = canalferramenta

const Aprovarplanoplanmodal = ({
  open,
  close,
  loading,
  loadingUsers,
  loadingIntegracao,
  loadingBuscarDestino,
  loadingValidarUrl,
  loadingGravarDestino,
  submitting,
  data,
  usuarios,
  integracao,
  destinoSalvo,
  urlValidada,
  nls,
  onBuscarDestino,
  onValidarUrl,
  onGravarDestino,
  onSubmit
}) => {
  const plano = data?.plano || null

  const [problemaAcaoState, setProblemaAcaoState] = useState({
    tipoAcao: 'padrao',
    acaoId: null,
    comentarioAcao: '',
    tituloPersonalizado: '',
    descricaoPersonalizada: '',
    deadline: '',
    todasRecomendadas: false
  })

  const [responsavelParticipantesState, setResponsavelParticipantesState] = useState({
    responsavel: {},
    participantes: []
  })

  const [canalFerramentaState, setCanalFerramentaState] = useState({
    canal: 'email',
    urlProjeto: '',
    urlValidada: false,
    projetoExternoId: null,
    listExternoId: null,
    ferramentaGestaoId: null,
    nomeDestino: '',
    issueTypeId: null,
    issueTypeOptions: [],
    issueTypeSelecionado: {},
    configuracaoConfirmada: false
  })


  //Ajuste para limpar os states quando o formulário for fechado
    useEffect(() => {
      if (!open) {
        setProblemaAcaoState({
          tipoAcao: 'padrao',
          acaoId: null,
          comentarioAcao: '',
          tituloPersonalizado: '',
          descricaoPersonalizada: '',
          deadline: '',
          todasRecomendadas: false
        })

        setResponsavelParticipantesState({
          responsavel: {},
          participantes: []
        })

        setCanalFerramentaState({
          canal: 'email',
          urlProjeto: '',
          urlValidada: false,
          projetoExternoId: null,
          listExternoId: null,
          ferramentaGestaoId: null,
          nomeDestino: '',
          issueTypeId: null,
          issueTypeOptions: [],
          issueTypeSelecionado: {},
          configuracaoConfirmada: false
        })
      }
    }, [open])




  const nomePlano = plano
    ? `${nls.planLabel} ${plano.numero_plano} - ${plano.titulo_plano || ''}`
    : ''

  const podeAprovar = useMemo(() => {
    const deadlinePreenchido = !!problemaAcaoState?.deadline
    const responsavelPreenchido = !!responsavelParticipantesState?.responsavel?.value

    if (!deadlinePreenchido || !responsavelPreenchido) {
      return false
    }

    if (problemaAcaoState?.tipoAcao === 'padrao') {
      if (!problemaAcaoState?.todasRecomendadas && !problemaAcaoState?.acaoId) {
        return false
      }
    }

    if (problemaAcaoState?.tipoAcao === 'personalizada') {
      const tituloPreenchido = !!String(problemaAcaoState?.tituloPersonalizado || '').trim()
      const descricaoPreenchida = !!String(problemaAcaoState?.descricaoPersonalizada || '').trim()

      if (!tituloPreenchido || !descricaoPreenchida) {
        return false
      }
    }

    if (canalFerramentaState?.canal === 'ferramenta') {
      if (!canalFerramentaState?.urlValidada) {
        return false
      }

      if (!canalFerramentaState?.ferramentaGestaoId) {
        return false
      }

      if (!canalFerramentaState?.projetoExternoId) {
        return false
      }

      const ehJira = integracao?.ferramentaCodigo === 'jira'
      const ehTrello = integracao?.ferramentaCodigo === 'trello'
      const ehMonday = integracao?.ferramentaCodigo === 'monday'

      if (ehJira) {
        if (!canalFerramentaState?.issueTypeId) {
          return false
        }

        if (!canalFerramentaState?.configuracaoConfirmada) {
          return false
        }
      }

      if (ehTrello && !canalFerramentaState?.listExternoId) {
        return false
      }

      if (ehMonday) {
        if (!canalFerramentaState?.listExternoId) {
          return false
        }

        if (!canalFerramentaState?.configuracaoConfirmada) {
          return false
        }
      }


    }

    return true
  }, [
    problemaAcaoState,
    responsavelParticipantesState,
    canalFerramentaState
  ])

  const handleAprovar = () => {
    const ehPersonalizada = problemaAcaoState?.tipoAcao === 'personalizada' ? 1 : 0

    const payload = {
      planoId: plano?.pdca_plano_id || 0,
      responsavelExecutarId: responsavelParticipantesState?.responsavel?.value || 0,
      deadline: problemaAcaoState?.deadline || '',
      acaoObj: {
        ehPersonalizada,
        acaoId: ehPersonalizada
          ? 0
          : (problemaAcaoState?.acaoId || 0),
        conteudoPersonalizado: ehPersonalizada
          ? (problemaAcaoState?.descricaoPersonalizada || '')
          : '',
        tituloPersonalizado: ehPersonalizada
          ? (problemaAcaoState?.tituloPersonalizado || '')
          : '',
        comentarioAcao: ehPersonalizada
          ? ''
          : (problemaAcaoState?.comentarioAcao || '')
      },
      usersId: Array.isArray(responsavelParticipantesState?.participantes)
        ? responsavelParticipantesState.participantes.map(item => item?.value).filter(Boolean)
        : [],
      integracao: {
        ehIntegrado: canalFerramentaState?.canal === 'ferramenta' ? 1 : 0,
        ferramentaGestaoId: canalFerramentaState?.canal === 'ferramenta'
          ? (canalFerramentaState?.ferramentaGestaoId || 0)
          : 0,
        projetoExternoId: canalFerramentaState?.canal === 'ferramenta'
          ? (canalFerramentaState?.projetoExternoId || '')
          : '',
        listExternoId: canalFerramentaState?.canal === 'ferramenta'
          ? (canalFerramentaState?.listExternoId || null)
          : null
      }
    }

    onSubmit(payload)
  }

  return (
    <Modal
      name='aprovar-plano-plan'
      cy='pdca-plan-approve'
      title={nls.approvePlanTitle}
      open={open}
      close={close}
      closeText={nls.close}
      size='large'
      actions={(
        <div className='aprovarplanoplanmodal__footer-actions'>
          <Button
  data-cy='pdca-plan-approve-close'
  data-cy-effect='read'
  color='default'
  onClick={close}
  disabled={submitting}
>
  {nls.close}
</Button>

          <Button
  data-cy='pdca-plan-approve-confirm'
  data-cy-effect='write'
  color='primary'
  disabled={!podeAprovar || submitting}
  onClick={handleAprovar}
>
  {nls.approve}
</Button>
        </div>
      )}
    >
      <div className='aprovarplanoplanmodal'>
        {loading && (
          <div className='aprovarplanoplanmodal__loading'>
            {nls.loading}
          </div>
        )}

        {!loading && plano && (
          <div className='aprovarplanoplanmodal__content'>
            <div className='aprovarplanoplanmodal__plan-name'>
              {nomePlano}
            </div>

            <div className='aprovarplanoplanmodal__section'>
              <Problemaacao
                data={data}
                nls={nls}
                value={problemaAcaoState}
                onChange={setProblemaAcaoState}
              />
            </div>

            <div className='aprovarplanoplanmodal__section'>
              <Responsavelparticipantes
                usuarios={usuarios}
                loadingUsers={loadingUsers}
                nls={nls}
                value={responsavelParticipantesState}
                onChange={setResponsavelParticipantesState}
              />
            </div>

            <div className='aprovarplanoplanmodal__section'>
              <Canalferramenta
                integracao={integracao}
                destinoSalvo={destinoSalvo}
                urlValidada={urlValidada}
                loadingIntegracao={loadingIntegracao}
                loadingBuscarDestino={loadingBuscarDestino}
                loadingValidarUrl={loadingValidarUrl}
                loadingGravarDestino={loadingGravarDestino}
                nls={nls}
                value={canalFerramentaState}
                onChange={setCanalFerramentaState}
                onBuscarDestino={onBuscarDestino}
                onValidarUrl={onValidarUrl}
                onGravarDestino={onGravarDestino}
              />
            </div>
          </div>
        )}
      </div>
    </Modal>
  )
}

export default Aprovarplanoplanmodal